import {createSelector} from "@reduxjs/toolkit";

import type {PermissionRule} from "../util/permissions";
import {checkPermissionRule} from "../util/permissions";
import {
    selectFullName,
    selectLicenseDisplayName,
    selectLicenseName,
    selectPermissions,
    selectUsername,
} from "./authSlice";
import type {RevaRootState} from "./store";

const permissionCheckSelectorCache = new Map<PermissionRule | undefined, (state: RevaRootState) => boolean>();

export const selectPermissionCheck = (rule: PermissionRule | undefined) => {
    if (!permissionCheckSelectorCache.has(rule)) {
        permissionCheckSelectorCache.set(
            rule,
            createSelector([selectPermissions], (permissions) => checkPermissionRule(permissions, rule)),
        );
    }
    return permissionCheckSelectorCache.get(rule)!;
};

export const selectFullNameOrUsername = createSelector(
    [selectFullName, selectUsername],
    (fullName, username) => fullName || username,
);

export const selectLicenseDisplayNameOrName = createSelector(
    [selectLicenseDisplayName, selectLicenseName],
    (displayName, name) => displayName || name,
);
